
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorcycle-rides",
      function () {
        return require("private-next-pages/motorcycle-rides.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorcycle-rides"])
      });
    }
  